import { Injectable } from '@angular/core';
import { DialogService } from '@mode/shared/ui';
import { ISecret } from '@mode/notebooks/contract';
import { ToastService } from '@mode/shared/util-toast';
import { NotebookSecretModalEditComponent } from './notebook-secret-modal-edit/notebook-secret-modal-edit.component';
import { NotebookSecretModalCreateComponent } from './notebook-secret-modal-create/notebook-secret-modal-create.component';

@Injectable()
export class NotebookSecretModalService {
  constructor(
    private dialogService: DialogService,
    private toastService: ToastService
  ) {}

  public openCreateModal(secretKeys: string[]): void {
    if (secretKeys.length >= 100) {
      this.toastService.error(
        'You have reached the maximum of 100 secrets for this notebook. Please delete an existing secret to add a new one.'
      );
      return;
    }
    this.dialogService.open({
      component: NotebookSecretModalCreateComponent,
      matDialogConfig: {
        backdropClass: 'cdk-overlay-dark-backdrop',
        data: {
          secretKeys,
        },
      },
    });
  }

  public openEditModal(secret: ISecret, cb: () => void): void {
    const dialogRef = this.dialogService.open({
      component: NotebookSecretModalEditComponent,
      matDialogConfig: {
        backdropClass: 'cdk-overlay-dark-backdrop',
        data: {
          secret,
        },
      },
    });
    dialogRef.afterClosed().subscribe(() => cb());
  }
}
